import React from "react";

type EmptyStateProps = {
  message: string;
};

export const EmptyState = ({ message }: EmptyStateProps) => {
  return (
    <div className="PreviewBookingModalBeta__noPreorders text-center text-muted-foreground py-8 italic">
      {message}
    </div>
  );
};
